"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("@emotion/react");
var _react2 = _interopRequireDefault(require("react"));
var _ = require("../../..");
var _Text = _interopRequireDefault(require("../../../core/Text"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CustomTooltip = ({
  lineConfig,
  barConfig,
  active,
  payload,
  label,
  allowDecimals,
  ...rest
}) => {
  const {
    formatter
  } = rest;
  const theme = (0, _react.useTheme)();
  const configHasProperty = config => config?.length && config.findIndex(v => v?.hasOwnProperty('shortName')) !== -1;
  const payloadItemHasProperty = (config, payloadItem) => config.findIndex(v => v.name === payloadItem.name && v.shortName) !== -1;
  const getTooltipItemName = payloadItem => {
    if (!lineConfig && !barConfig) return payloadItem.name;
    if (lineConfig && configHasProperty(lineConfig) && payloadItemHasProperty(lineConfig, payloadItem)) {
      return lineConfig?.find(v => v.name === payloadItem.name)?.shortName;
    }
    if (barConfig && configHasProperty(barConfig) && payloadItemHasProperty(barConfig, payloadItem)) {
      return barConfig?.find(v => v.name === payloadItem.name)?.shortName;
    }
    return payloadItem.name;
  };
  const TooltipPayload = () => {
    return active && payload?.length && payload.map((item, index) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.TooltipPayloadWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ItemNameGroup, {
        children: [item?.stroke && /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
          width: "16",
          height: "16",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
            x1: "0",
            y1: "8",
            x2: "16",
            y2: "8",
            style: {
              stroke: item.color,
              strokeWidth: '3px'
            }
          })
        }), item?.fill && !item?.stroke && /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
          width: "16",
          height: "16",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            width: "100%",
            height: "100%",
            rx: "3",
            fill: item.color
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Text.default, {
          children: [getTooltipItemName(item), ":"]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        children: allowDecimals ? formatter ? formatter((0, _.getFormattedPrice)(item.value, 2), getTooltipItemName(item), payload[index], index, payload) : (0, _.getFormattedPrice)(item.value, 2) : (0, _.getFormattedPrice)(item.value, 0)
      })]
    }, item.name));
  };
  if (!active) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.TooltipWrapper, {
    theme: theme,
    children: [label && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      bold: true,
      children: label
    }), TooltipPayload()]
  });
};
var _default = exports.default = CustomTooltip;